import Axios from "axios";
import store from "@/store";
import {
  resolveOperatorSupportContext,
  SUPPORT_SCOPE_INTERNAL,
  SUPPORT_SCOPE_PROJECT,
} from "@/utils/supportContext";

function resolveScope(requestedScope) {
  const normalizedScope = String(requestedScope || "").toUpperCase();
  if (
    normalizedScope === SUPPORT_SCOPE_PROJECT ||
    normalizedScope === SUPPORT_SCOPE_INTERNAL
  ) {
    return normalizedScope;
  }
  return resolveOperatorSupportContext(store?.state || {}).escopo;
}

class SupportTeamMemberDataService {
  constructor(requestedScope = null) {
    this.requestedScope = requestedScope;
  }

  scopedParams(params = {}) {
    return {
      ...params,
      escopo: resolveScope(this.requestedScope),
    };
  }

  getAll() {
    return Axios.get("supportTeamMembers", { params: this.scopedParams() });
  }

  getPage(params) {
    return Axios.get("supportTeamMembers/page", {
      params: this.scopedParams(params),
    });
  }

  create(payload) {
    return Axios.post("supportTeamMembers", payload, {
      params: this.scopedParams(),
    });
  }

  update(payload) {
    return Axios.put("supportTeamMembers/" + payload.id, payload, {
      params: this.scopedParams(),
    });
  }

  find(id) {
    return Axios.get(`supportTeamMembers/${id}`, {
      params: this.scopedParams(),
    });
  }

  delete(id) {
    return Axios.delete(`supportTeamMembers/${id}`, {
      params: this.scopedParams(),
    });
  }
}

export function createSupportTeamMemberDataService(requestedScope = null) {
  return new SupportTeamMemberDataService(requestedScope);
}

export default new SupportTeamMemberDataService();
